import * as React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { setSort } from 'actions/filters';
import { ISortModel } from 'reducers/filters/models';
import { fetchCostAndRevenue, addCostAndRevenue } from 'actions/costRevenue';
import { setSelectedInvoices } from 'actions/invoices';
import { IStore } from 'reducers/index';
import { IResponse } from 'reducers/bookings/models';
import CostColumnsData from '../../../views/job-costing/utils/CostColumnsData';
import { InPageDialog } from 'damco-components';
import { HandleError } from 'components/handle-error';
import { INickname } from 'reducers/nickname';
import { AddEditDialog } from 'modules/cost-revenue/dialog/AddEditDialog';
import {
    checkType, haveLoginData, convertNumbers, addQuantityDistribution, getEmptyCostRev,
    convertChildren, formatChildren, convertDataToDialog, FinOpsStatusPermission, formatDates, getVatPartnerData
}
    from '../../../views/job-costing/utils/CostAndRevenueHelpers';
import { UserDataControl } from 'components/cost-revenue/UserDataControl';
import { ItemCategoryCheck } from 'modules/cost-revenue/component/ItemCategoryCheck';
import { CostAndRevenueTablesWrap } from './CostAndRevenueTablesWrap';
import { CostRevEmptyData } from 'constants/costRevenue';
import { ICostRevDistribution } from 'constants/costRevModels';
import { formatValueIfNullOrUndefined, isFeatureEnabled, sortElementByKey } from 'utilities/util';
import * as validationConstants from 'constants/validationMessages';
import { status_text } from 'components/exception-management/constants';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { fcrType, timeDelay } from 'constants/customs';
import { fetchSalesOrderData, setExportJobSalesOrderId } from 'actions/salesOrder';
import { ModalScreen } from 'components/modal-screen';
import { SalesOrders } from '../../../modules/salesorders/SalesOrders';
import { ModalType } from 'components/modal-screen/ModalType';
import { targetFunctionality } from 'constants/targetFunctionality';
import * as validationMessages from 'constants/validationMessages';
import { ATHENA, SUCCESS_MESSAGE } from 'constants/messages';
import { fetchExportJobDetails } from 'actions/exportJob';
import { fetchETSDetails } from 'actions/ets';
import { BLOCKED_TYPES } from 'constants/blockedTypes';

interface IParams {
    costAndRevenueId: number;
    fStatus: string[];
    readOnly: boolean;
    partyData: any;
    targetId: number | string;
    docId: number | string;
    showInvoices: boolean;
    invoicesData?: any;
    splitCols: any[];
    distributionData?: any;
    targetType: string; // 'origin' | 'destination';
    outputCostRev: (cost: any[], revenue: any[]) => void;
    navigateTo?: (url: string) => void;
    getCurrentPageMode?: (mode: string) => void;
    toggleTabs: (b: boolean) => void;
    eventCallback: () => void;
    costAndrevenueresponse: IResponse;
    type?: string;
    businessSubCategory?: string;
    isJobClosed?: boolean;
    isSourceAthena?: boolean;
    isNftpBillable?: boolean;
    isNftpRoeEnabled?: boolean;
}
interface IMapDispatchToProps {
    setSelectedInvoices: (dataList: any) => void;
    fetchCostAndRevenue: (type: number, valueId: any[], targetType: string) => Promise<void>;
    addCostAndRevenue: (data: any, targetType: string, vatPartnersData?: any) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    fetchSalesOrderData: (id: number, page?: number, pageSize?: number) => Promise<void>;
    setExportJobSalesOrderId: (id: number) => void;
    fetchETSDetails: (documentId: string) => Promise<void>;
    fetchExportJobDetails: (exportJobId: number) => Promise<void>;
}
interface IMapStateToProps {
    isFetchDataLoading: boolean;
    isFetchDataError: boolean;
    pendingError: string | string[],
    feedbackResponse: any;
    nickname: INickname;
    featureToggles: IFeatureToggleModel[];
    salesOrderResponse: any;
    salesOrderId: number;
}

interface IProps extends IParams, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    hasZero: boolean;
    canInvoice: boolean;
    page: number;
    pageSize: number;
    fetchInProgress: boolean;
    pendingError: string | string[];
    cost: any[];
    data: any[];
    revenue: any[];
    isCostEditMode: boolean;
    isRevenueEditMode: boolean;
    showDialog: boolean;
    showErrorModal: boolean;
    validationError: any;
    showModal: boolean;
    dialogData: any;
    footerUpdate: boolean;
    pendingConfirmation: boolean;
    response: IResponse;
    showAddSalesOrderModal: boolean;
    currentIndex: number,
    showChargeItemDialog: boolean;
    originalDynamicFieldsJson?: any[];
}
export class _CostAndRevenue extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            hasZero: false,
            canInvoice: false,
            page: 1,
            pageSize: 10,
            fetchInProgress: true,
            footerUpdate: false,
            pendingError: '',
            cost: [],
            data: [],
            revenue: [],
            isCostEditMode: false,
            isRevenueEditMode: false,
            validationError: {
                target: '',
                message: '',
                keys: []
            },
            showDialog: false,
            showErrorModal: false,
            showModal: false,
            dialogData: {
                data: [],
                type: '',
                target: '',
                targetFunctionality: '',
                dependencies: []
            },
            pendingConfirmation: false,
            response: {
                result: []
            },
            showAddSalesOrderModal: false,
            currentIndex: 0,
            showChargeItemDialog: false,
            originalDynamicFieldsJson: []
        };
    }
    public componentDidMount = () => {
        if (this.props.costAndrevenueresponse.result.length > 0) {
            this.setState({
                response: this.props.costAndrevenueresponse
            });
            setTimeout(() => {
                this.storeDynamicFields();
                this.splitData();
            }, timeDelay.costRevenue);
        }
    };
    public componentDidUpdate = (prevProps: any, prevState: any) => {
        if (this.props.costAndrevenueresponse.result !== prevProps.costAndrevenueresponse.result) {
            this.setState({
                showDialog: false,
                pendingError: '',
                response: this.props.costAndrevenueresponse
            });
            setTimeout(() => {
                this.splitData();
            }, timeDelay.costRevenue);
        }
        if (this.props.pendingError !== prevProps.pendingError) {
            let checkText = this.props.pendingError;
            if ((Array.isArray(this.props.pendingError) && this.props.pendingError.length === 0) ||
                this.props.pendingError === '') {
                checkText = validationConstants.CostAndRevenue.Error_Add_charges;
            }
            this.setState({
                showDialog: true,
                footerUpdate: true,
                pendingError: checkText
            });
            setTimeout(this.clearUpdate, 1000);
        }
        if (this.props.feedbackResponse && this.props.feedbackResponse !== prevProps.feedbackResponse) {
            if (this.props.feedbackResponse === SUCCESS_MESSAGE) {
                this.setState({
                    pendingConfirmation: false,
                    footerUpdate: true,
                });
                if (this.props.targetType === 'destination') {
                    this.props.fetchETSDetails(this.props.costAndRevenueId.toString());
                } else {
                    this.props.fetchExportJobDetails(this.props.costAndRevenueId);
                }
                this.props.fetchCostAndRevenue(Number(this.props.targetId), [this.props.costAndRevenueId], this.props.targetType);
                setTimeout(this.clearUpdate, 1000);
            }
        }

        if (this.state.showDialog !== prevState.showDialog && this.state.showDialog) {
            window.scroll(0, 0);
        }
        if (this.state.showAddSalesOrderModal !== prevState.showAddSalesOrderModal && this.state.showAddSalesOrderModal) {
            if (this.props.salesOrderResponse.data[0].isClosed === 'CLOSED') {
                this.setState({
                    showChargeItemDialog: true
                });
            } else {
                this.setState({
                    showChargeItemDialog: false
                });
            }
        }
    };
    public getType = () => {
        switch (this.props.targetId) {
            case 2:
                return 'equipment';
                break;
            case 3:
                return 'cbl';
                break;
            case 4:
                return 'fcr';
                break;
            case 5:
                return 'ets';
                break;
        }
        return 'booking';
    };
    public render() {
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        return (
            <React.Fragment>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.pendingError}
                    closeMethod={() => this.setState({ showDialog: false, pendingError: '' })} />
                <HandleError
                    error={this.props.pendingError}
                />
                {this.state.showModal &&
                    <AddEditDialog
                        jobId={this.props.docId ? Number(this.props.docId) : 0}
                        targetFunctionality={this.props.targetId}
                        isDestination={this.props.targetType === 'destination' ? true : false}
                        {...this.state.dialogData}
                        shouldDisplay={this.state.showModal}
                        onSave={(data: any | null, target: string, closeAfterSave: boolean) => this.consolidateDialogData(data, target, closeAfterSave)}
                        onClose={(target: string) => { this.closeModal(target); this.props.toggleTabs(false); this.splitData(); }}
                        partyData={this.props.partyData}
                        salesOrderNumber={this.props.salesOrderResponse &&
                            this.props.salesOrderResponse.data.length > 1 ?
                            this.props.salesOrderResponse.data[this.state.currentIndex].salesOrderNumber : ''}
                        isSourceAthena={this.props.isSourceAthena}
                    />}
                {!this.state.showModal && <div>
                    <ItemCategoryCheck
                        displayDialog={this.state.showErrorModal}
                        message={FinOpsStatusPermission(this.props.fStatus, null) ? validationConstants.CostAndRevenue.Alert_Charge_locked : validationConstants.CostAndRevenue.Alert_Status_Charge_locked}
                        closeDialog={() => { this.setState({ showErrorModal: false }); }} />
                    {this.state.showAddSalesOrderModal &&
                        <div className={this.state.showChargeItemDialog ? 'status-block' : ''}>
                            <ModalScreen
                                title={'Sales Order Table'}
                                id={'salesOrderModalScreen'}
                                modalType={ModalType.m()}
                                visible={this.state.showAddSalesOrderModal}
                                closeModal={() => this.setState({ showAddSalesOrderModal: false })}
                                secondaryButtonFunc={() => {
                                    this.setState({ showAddSalesOrderModal: false });
                                }}
                                primaryButtonTitle="OK"
                                primaryButtonFunc={() => {
                                    this.setState({ showAddSalesOrderModal: false });
                                    this.tablePrimaryAction('', CostColumnsData.TYPES.COST);
                                }}
                                secondaryButtonTitle="Cancel"
                                primaryButtonId="SalesOrderModal"
                            >
                                <div>
                                    <div><InPageDialog showDialog={this.state.showChargeItemDialog} type={'error'} message={validationMessages.CostAndRevenue.Error_Job_Close} />  </div>
                                    <SalesOrders targetId={this.props.costAndRevenueId} isModalOpen={true}
                                        salesOrderResponse={this.props.salesOrderResponse}
                                        index={this.state.currentIndex}
                                        setCurrentIndex={this.onSalesOrderModalRadioButtonChange}
                                        isResendMessageFeatureEnabled={isFeatureEnabled(FEATURE_TOGGLES.RESEND_LAST_MESSAGE, this.props.featureToggles)}
                                    />
                                </div>
                            </ModalScreen>
                        </div>
                    }
                    <UserDataControl
                        nickname={this.props.nickname}
                    />
                    {this.props.targetId && <CostAndRevenueTablesWrap
                        funcName={this.getType()}
                        showInvoices={this.props.showInvoices && !this.state.hasZero && this.state.canInvoice}
                        forceFooterUpdate={this.state.footerUpdate}
                        finOpsStatus={this.props.fStatus}
                        readOnly={this.props.readOnly}
                        revenue={this.state.revenue}
                        cost={this.state.cost}
                        splitCols={this.props.splitCols}
                        isFetchLoading={this.props.isFetchDataLoading}
                        fetchData={this.tableOrderFetch}
                        addAction={this.checkSalesOrderForReceivingFCR}
                        editAction={this.tableEdit}
                        deleteAction={this.deleteRevenue}
                        setSelectedInvoices={(props: any) => this.setSelectedInvoices(props)}
                        vatPartnersEdit={this.vatPartnersEdit}
                        billToPartyEdit={this.billToPartyEdit}
                        isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                        isJobClosed={this.props.isJobClosed}
                        salesOrderResponse={this.props.salesOrderResponse.data}
                        isReceivingFCR={this.props.businessSubCategory && this.props.businessSubCategory === fcrType.RECEIVING ? true : false}
                        isSourceAthena={this.props.isSourceAthena}
                        isNftpBillable={this.props.isNftpBillable}
                        isNftpRoeEnabled={this.props.isNftpRoeEnabled}
                        vendorsData={{
                            targetId: this.props.targetId,
                            costAndRevenueId: this.props.costAndRevenueId
                        }}
                    />}
                </div>}
            </React.Fragment>
        );
    }
    private tableOrderFetch = (target: any, tableData: any, dataType?: string) => {
        if (tableData.sorted && tableData.sorted[0]) {
            let tData: any = [];
            if (target === CostColumnsData.TYPES.COST) {
                tData = this.state.cost;
                this.setState({ cost: sortElementByKey(tData, tableData.sorted[0].id, tableData.sorted[0].desc, dataType) });
            } else {
                tData = this.state.revenue;
                this.setState({ revenue: sortElementByKey(tData, tableData.sorted[0].id, tableData.sorted[0].desc, dataType) });
            }
        }
        this.setState({
            footerUpdate: true,
            page: tableData.page + 1 !== this.state.page ? tableData.page + 1 : this.state.page,
            pageSize: tableData.pageSize !== this.state.pageSize ? tableData.pageSize : this.state.pageSize
        });
        setTimeout(this.clearUpdate, 1000);
    };
    private clearUpdate = () => {
        this.setState({ footerUpdate: false });
    };
    private splitData = () => {
        if (this.state.response.result.length === 0) {
            return;
        }
        const data: any = this.props.targetType === 'origin' ?
            [...this.state.response.result[0].essoRateDetailsModels] :
            [...this.state.response.result[0].issoChargeLines];
        let costs: any = [];
        let revenues: any = [];
        const getHTML = (text: string) => {
            return <span dangerouslySetInnerHTML={{ __html: `${status_text.negative} ${text}` }} />;
        };

        data.map((element: any, index: number) => {
            element.id = index;
            element.viewAdded = element.viewAdded && element.viewAdded === 'EXPORT_JOB' ? element.viewAdded.replace(/_/g, '') : element.viewAdded;
            element.billToParty = element.billToParty;
            element.billToPartyName = element.billToPartyName;
            element.payToParty = element.payToParty;
            element.payToPartyName = element.payToPartyName;
            element.ServiceProvider = (element.payToParty && element.payToPartyName)
                ? `${element.payToParty} - ${element.payToPartyName}`
                : element.payToParty || element.payToPartyName || '-';
            if (this.props.targetType === 'destination') {
                element.essoRateDetailId = element.rateDetailId;
                element.essoRateDetailSplitId = element.rateDetailSplitId;
                element.uom = element.unitOfMeasure;
            }
            if (element.materialCode) {
                element.chargeItem = element.materialCode;
            }

            element.chargeItem = element.errorReason && element.errorReason.length > 0 ? getHTML(element.chargeItem) : element.chargeItem;
            element.icbIndicator = formatValueIfNullOrUndefined(element.icbIndicator);
            element.athenaRateIdentifier = formatValueIfNullOrUndefined(element.athenaRateIdentifier);
            element.chargeValidityBased = formatValueIfNullOrUndefined(element.chargeValidityBased);
            element.contractStartDate = formatValueIfNullOrUndefined(element.contractStartDate);
            element.contractEndDate = formatValueIfNullOrUndefined(element.contractEndDate);
            element.serviceRenderedAt = element.serviceRenderedAt ? this.getServiceRenderedAt(element.serviceRenderedAt) : formatValueIfNullOrUndefined(element.serviceRenderedAt);
            element.vatPartner = element.vatPartner ? element.vatPartner : '';
            element.vatPartnerReasonCodeNo = '';
            element.specialPricingCondition = element.specialPricingCondition === true || element.specialPricingCondition === 'Y' ? 'Y' : 'N';
            element.netValue = element.netValue ? element.netValue : 0.00;
            element.secondaryRateIdentifier = formatValueIfNullOrUndefined(element.athenaRateIdentifier);
            element.triggerDocumentNumber = formatValueIfNullOrUndefined(element.triggerDocumentNumber);
            element.blockedType = element.blockedType !== BLOCKED_TYPES.UNBLOCK ? element.blockedType : '';
            formatDates(element);
            convertNumbers(element, false, element.specialPricingCondition === 'Y');
            if (element.costAndRevenueDetails) {
                const quantity = this.props.targetId === 5 ? element.quantity : 0;
                const etsId = this.props.targetId === 5 ? Number(this.props.docId) : 0;
                element.children = formatChildren(element.costAndRevenueDetails, quantity, etsId);
            }
            if (element.dynamicFields) {
                try {
                    const dynamicFields = JSON.parse(element.dynamicFields);
                    element.dynamicFields = dynamicFields.map((field: any) => field.value).join(', ');
                } catch (error) {
                    element.dynamicFields = element.dynamicFields;
                }
            }
            if (checkType(element) === CostColumnsData.TYPES.REVENUE) {
                revenues.push(element);
            } else {
                costs.push(element);
            }
        });
        this.props.outputCostRev(costs, revenues);
        costs = sortElementByKey(costs, 'itemNumber', true, 'number');
        revenues = sortElementByKey(revenues, 'itemNumber', true, 'number');
        const billableRevenues: any[] = revenues.filter((item: any) => {
            return String(item.status) === 'Linked to Sales Order';
        });
        const revZero: any[] = billableRevenues.filter((item: any) => {
            return Number(item.quantity) <= 0 || Number(item.rate) <= 0;
        });
        this.setState({
            hasZero: revZero.length > 0,
            canInvoice: this.state.response.result[0].canInvoice,
            data: [...data],
            cost: [...costs],
            revenue: [...revenues],
            fetchInProgress: false,
        });
    };
    private storeDynamicFields = () => {
        if (this.state.response.result.length === 0) {
            return;
        }
        const data: any = this.props.targetType === 'origin' ?
            [...this.state.response.result[0].essoRateDetailsModels] :
            [...this.state.response.result[0].issoChargeLines];

        const dynamicFieldsJsonArray: any[] = [];

        data.map((element: any, index: number) => {
            element.id = index;
            if (element.dynamicFields) {
                dynamicFieldsJsonArray.push(
                    {
                        id: element.id,
                        originalDynamicFields: element.dynamicFields
                    }
                );
            }
            this.setState({
                originalDynamicFieldsJson: dynamicFieldsJsonArray
            });
        });
    };
    private getServiceRenderedAt = (value: any) => {
        if (typeof value === 'number') {
            const serviceRenderedAtMap = {
                1: 'ORIGIN',
                2: 'DESTINATION',
                3: 'FREIGHT',
            };
            return serviceRenderedAtMap[value] || '-';
        }
        return value;
    };
    private consolidateDialogData = (data: any | null, target: string, closeAfterSave: boolean) => {
        if (data && closeAfterSave) {
            this.saveRevenue(data, target, true);
            this.setState({
                showModal: false
            });
        } else if (data && !closeAfterSave) {
            this.saveRevenue(data, target, false);
        } else {
            this.closeModal(target);
        }
        this.props.toggleTabs(false);
        this.passCurrentMode('');
    };
    private closeModal = (e: string) => {
        let isEdit: any = { isRevenueEditMode: false };
        if (e === CostColumnsData.TYPES.COST) {
            isEdit = { isCostEditMode: false };
        }
        this.setState({
            ...isEdit,
            showModal: false,
            showAddSalesOrderModal: false,
            dialogData: {
                data: [],
                vendorsData: [],
                type: '',
                target: '',
                targetFunctionality: '',
                dependencies: []
            }
        });
        this.passCurrentMode('');
    };

    private passCurrentMode = (mode: string) => {
        if (this.props.getCurrentPageMode) {
            this.props.getCurrentPageMode(mode);
        }
    };
    private onSalesOrderModalRadioButtonChange = (index: number) => {
        if (this.props.salesOrderResponse.data[index].isClosed === 'CLOSED') {
            this.setState({
                showChargeItemDialog: true
            });
        } else {
            this.setState({
                showChargeItemDialog: false
            });
        }
        this.props.setExportJobSalesOrderId(Number(this.props.salesOrderResponse.data[index].id));
        this.setState({
            currentIndex: index
        });
    };
    private checkSalesOrderForReceivingFCR = async (e: any, target: string) => {
        if (this.props.businessSubCategory && this.props.businessSubCategory === fcrType.RECEIVING && target === 'COST') {
            await this.props.fetchSalesOrderData(this.props.costAndRevenueId, this.state.page, this.state.pageSize);
            this.props.salesOrderResponse.data.length > 0 ? this.props.setExportJobSalesOrderId(Number(this.props.salesOrderResponse.data[0].id))
                : this.props.setExportJobSalesOrderId(0);
            if (this.props.salesOrderResponse.data.length > 1) {
                this.setState({ showAddSalesOrderModal: true });
            } else {
                this.tablePrimaryAction(e, target);
                this.setState({ showAddSalesOrderModal: false });
            }
        } else {
            this.tablePrimaryAction(e, target);
        }
    };
    private tablePrimaryAction = (e: any, target: string) => {
        const emtpyData = CostRevEmptyData;
        if (haveLoginData(this.props.nickname)) {
            emtpyData.localCurrency = CostColumnsData.GetLocalCurrency(this.props.partyData.country);
            emtpyData.insertBy = this.props.nickname.employeeId;
            emtpyData.itemType = this.props.nickname.employeeId;
            const lastId = this.state.data.length === 0 ? 1 : this.state.data.slice(-1)[0].id;
            emtpyData.id = lastId + 1;
            let vendorsData: any[] = [];
            if (target === CostColumnsData.TYPES.COST) {
                emtpyData.itemCategory = CostColumnsData.TYPES.COST;
                vendorsData = [
                    this.props.targetId,
                    this.props.costAndRevenueId
                ];
                this.setState({
                    isCostEditMode: true
                });
            } else {
                emtpyData.itemCategory = CostColumnsData.TYPES.REVENUE;
                vendorsData = [
                    this.props.targetId,
                    this.props.costAndRevenueId
                ];
                this.setState({
                    isRevenueEditMode: true
                });
            }
            const children = this.getDistributionData(emtpyData.id);
            emtpyData.children = children;
            this.props.toggleTabs(true);
            this.setState({
                showModal: true,
                footerUpdate: false,
                dialogData: {
                    target,
                    vendorsData,
                    data: [{ ...emtpyData }],
                    readonlyState: false,
                    type: 'add',
                    targetFunctionality: this.props.targetId,
                    dependencies: children
                }
            });
            this.passCurrentMode('add');
        }
    };
    private tableEdit = (e: any, typeOfEdit: string) => {
        let data = [...e];
        const originalDynamicFieldsJson = this.state.originalDynamicFieldsJson;
        let target: any = { isCostEditMode: true };
        let vendorsData: any[] = [];
        if (typeOfEdit === CostColumnsData.TYPES.REVENUE) {
            target = { isRevenueEditMode: true };
            vendorsData = [
                this.props.targetId,
                this.props.costAndRevenueId
            ];
        }
        if (originalDynamicFieldsJson && originalDynamicFieldsJson.length) {
            data = data.map((item: any) => {
                const fieldsJson = originalDynamicFieldsJson.find((originalItem: any) => originalItem.id === item.id);
                item.dynamicFields = fieldsJson ? fieldsJson.originalDynamicFields : '';
                return item;
            });
        }
        if (haveLoginData(this.props.nickname)) {
            this.props.toggleTabs(true);
            this.setState({
                ...target,
                pendingError: ``,
                footerUpdate: false,
                showErrorModal: false,
                showDialog: false,
                showModal: true,
                dialogData: {
                    vendorsData,
                    data: convertDataToDialog(data),
                    type: 'edit',
                    readonlyState: false,
                    target: typeOfEdit,
                    targetFunctionality: this.props.targetId,
                    dependencies: []
                }
            });
            this.passCurrentMode('edit');
        }
    };
    private getDistributionData = (id: number): any[] => {
        let response = this.props.distributionData ? this.props.distributionData : this.state.response.result.length > 0 ? this.state.response.result[0].children : [];
        response = addQuantityDistribution(response.length, id, response);
        return response;
    };
    private deleteRevenue = (e: any, reason: string, target: string) => {
        const elDelete: any = [...e];
        if (elDelete && elDelete.length > 0) {
            const chargeItems = convertChildren(elDelete);
            const id: any[] = [];
            chargeItems.forEach((elem: any, index: number) => {
                // editCostAndRevenue
                id.push(elem.essoRateDetailId);
                if (this.props.targetId === targetFunctionality.Booking) {
                    elem.sourceType = 'Booking';
                    elem.bookingId = this.props.costAndRevenueId;
                }
                if (this.props.targetId === targetFunctionality.Equipment) {
                    elem.sourceType = 'Equipment';
                }
                if (this.props.targetId === targetFunctionality.CBL) {
                    elem.sourceType = 'CBL';
                }
                if (this.props.targetId === targetFunctionality.FCR_ExportJob) {
                    elem.sourceType = 'FCR';
                }
                if (this.props.targetId === targetFunctionality.ETS) {
                    elem.sourceType = 'ETS';
                }
                elem.documentId = this.props.docId;
                if (haveLoginData(this.props.nickname)) {
                    // If ATHENA charge item originally created by ATHENA, set updatedBy to current user
                    if (elem.itemType === 'ATHENA' && elem.updatedBy === 'ATHENA') {
                        elem.updatedBy = this.props.nickname.employeeId;
                    } else {
                        elem.updatedBy = this.props.nickname.employeeId;
                    }
                }
                elem.IsDeleted = true;
                elem.reasonCode = reason;
                return elem;
            });
            this.callAPI(chargeItems, 'addCostAndRevenue');
        }
    };
    private saveRevenue = (e: any[], target: string, shouldClearState = true) => {
        const chargeItems = [...e];
        // chargeItems = convertChildren(chargeItems)
        let opType: string = 'update';
        chargeItems.forEach((itemData: any) => {
            if (this.props.targetId === 1) {
                itemData.sourceType = 'Booking';
                itemData.bookingId = this.props.costAndRevenueId;
            }
            if (this.props.targetId === 2) {
                itemData.sourceType = 'Equipment';
            }
            if (this.props.targetId === 3) {
                itemData.sourceType = 'CBL';
            }
            if (this.props.targetId === 4) {
                itemData.sourceType = 'FCR';
            }
            if (this.props.targetId === 5) {
                itemData.sourceType = 'ETS';
            }
            itemData.documentId = this.props.docId;
            target === CostColumnsData.TYPES.COST ?
                itemData.exportSalesOrderId = this.props.salesOrderId : itemData.exportSalesOrderId = 0;
            if (!itemData.upadatedBy && haveLoginData(this.props.nickname)) {
                itemData.updatedBy = this.props.nickname.employeeId;
            }
            // save
            if (itemData && !itemData.essoRateDetailId) {
                opType = 'add';
            }
        });
        if (opType === 'add') {
            this.callAPI(chargeItems, 'addCostAndRevenue', shouldClearState);
            this.setState({
                pendingConfirmation: true,
                pendingError: ''
            });
        } else {
            // edit
            this.setState({
                footerUpdate: true
            });
            this.callAPI(chargeItems, 'editCostAndRevenue', true);
            setTimeout(this.clearUpdate, 1000);
        }
    };
    private callAPI = (data: any[], api: string, shouldClearState = true) => {
        const res: ICostRevDistribution = getEmptyCostRev(
            data[0].itemCategory,
            this.props.costAndRevenueId,
            data
        );
        if (res.ChargeItems.length) {
            res.ChargeItems = res.ChargeItems.map(item => {
                const isAthenaAdd = this.props.isSourceAthena && api === 'addCostAndRevenue';
                const isSpecialPricing = item.SpecialPricingCondition === true || item.SpecialPricingCondition === 'Y';
                const hasAthenaRateIdentifier = item.AthenaRateIdentifier ? true : false;
                const isAdhocAmendment = item.AdhocContractualAmendmentIdentifier ? true : false;
                const isDeleteOperation = item.IsDeleted === true;

                if (isAthenaAdd && isSpecialPricing) {
                    item.Rate = item.NetValue;
                }

                // Don't override UpdatedBy for delete operations
                if (isAthenaAdd && (hasAthenaRateIdentifier || isAdhocAmendment) && !isDeleteOperation) {
                    item.UpdatedBy = ATHENA;
                }
                return item;
            });
        }
        switch (api) {
            case 'addCostAndRevenue':
                this.props.addCostAndRevenue({ ...res }, this.props.targetType);
                break;
            case 'editCostAndRevenue':
                const vatPartnersDataEdit = getVatPartnerData(data, this.props.targetType);
                this.props.addCostAndRevenue({ ...res }, this.props.targetType, vatPartnersDataEdit);
                break;
        }
        if (shouldClearState) {
            this.props.eventCallback();
            this.setState({});
        }
    };
    private setSelectedInvoices = (props: any) => {
        this.props.setSelectedInvoices({
            type: 'single',
            list: [{
                fcrNumber: this.props.targetId !== 5 ? this.props.invoicesData.fcrNumber : undefined,
                etsNumber: this.props.targetId === 5 ? this.props.invoicesData.fcrNumber : undefined,
                fcrId: this.props.targetId !== 5 ? this.props.invoicesData.fcrId : undefined,
                etsId: this.props.targetId === 5 ? this.props.invoicesData.fcrId : undefined,
                billingCurrency: this.props.invoicesData.billingCurrency,
                billToParty: props.billToParty,
                consignee: this.props.invoicesData.consignee,
                icbIndicator: this.props.targetId !== 5
                    ? this.state.response.result[0]?.essoRateDetailsModels[0]?.icbIndicator
                    : this.state.response.result[0]?.issoChargeLines[0]?.icbIndicator || '-',
                companyCode: this.props.invoicesData && this.props.invoicesData.companyCode ?
                    this.props.invoicesData.companyCode.substring(0, 2) : '',
                selectedCharges: props.selectedCharges,
                primaryDocumentNumber: this.props.targetId !== 5 ? `${this.props.invoicesData.fcrNumber}/${this.props.invoicesData.finNumber}` : undefined
            }]
        });
        const url = `/customer-billing/issue-invoices/${this.props.targetType}/details/${this.state.response.result[0].searchId}`;
        if (this.props.navigateTo) {
            this.props.navigateTo(url);
        }
    };
    private vatPartnersEdit = () => {
        if (this.props.navigateTo) {
            this.props.navigateTo('/vat-partners-edit');
        }
    };
    private billToPartyEdit = () => {
        if (this.props.navigateTo) {
            this.props.navigateTo('/edit-bill-to-party-and-vat-partner');
        }
    };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchDataLoading: state.costRevenue.isFetchDataLoading,
    isFetchDataError: state.costRevenue.isFetchDataError,
    pendingError: state.costRevenue.pendingError,
    feedbackResponse: state.costRevenue.newCode,
    nickname: state.nickname.userNickName,
    featureToggles: state.featureToggle.featureToggles,
    salesOrderResponse: state.exportJob.salesOrderResponse,
    salesOrderId: state.exportJob.salesOrderId
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchCostAndRevenue: (type: number, valueId: any, targetType: string) => dispatch(fetchCostAndRevenue(type, valueId, targetType)),
    addCostAndRevenue: (data: any, targetType: string, vatPartnersData?: any) => dispatch(addCostAndRevenue(data, targetType, vatPartnersData)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    setSelectedInvoices: (dataList: any) => dispatch(setSelectedInvoices(dataList)),
    fetchSalesOrderData: (id: number, page?: number, pageSize?: number) => dispatch(fetchSalesOrderData(id, page, pageSize)),
    setExportJobSalesOrderId: (id: number) => dispatch(setExportJobSalesOrderId(id)),
    fetchExportJobDetails: (exportJobId: number) => dispatch(fetchExportJobDetails(exportJobId)),
    fetchETSDetails: (documentId: string) => dispatch(fetchETSDetails(documentId)),
});

export const CostAndRevenue = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_CostAndRevenue);